import { useEffect, useState } from 'react';

import { CUSTOMS_CODE_COUNTRIES } from '../../../constants/locations';
import { GeneratedAddress } from '../../../types/generated';

export const useCustomsCodeRequired = (
  addresses: GeneratedAddress[],
  selectedAddressId?: string,
) => {
  const [customsCodeIsRequired, setCustomsCodeIsRequired] = useState(false);

  useEffect(() => {
    const address = (addresses || []).find(
      ({ id }) => id === selectedAddressId,
    );
    setCustomsCodeIsRequired(
      CUSTOMS_CODE_COUNTRIES.includes(address?.countryCode || '') &&
        !address?.customsCode,
    );
  }, [addresses, selectedAddressId]);

  return {
    customsCodeIsRequired,
  };
};
